import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Moodboard from  "../../components/Moodboard/Moodboard";

const MoodboardComponent = () => {

  const [state, setState] = useState({ imageUrls: [] })

  useEffect(() => {
    axios.get('/api/v1/influencers/moodboard_images', {
      params: {
        offer_id: '4380'
      }
    }).then(({ data }) => {
      setState({ imageUrls: data.moodboard_images.map(obj => obj.url) });
    }).catch(function (error) {
      console.log(error);
    });
  }, []);

  return (
    <React.Fragment>
      <Row className="styles-section" id="moodboard">
        <Col xs={12}>
          <h3>Moodboard</h3>
        </Col>
        <Moodboard moodboardMedia={state.imageUrls} moodboardClassEnd=''/>
      </Row>
    </React.Fragment>
  )
};

export default MoodboardComponent;
